// Font family constants
const fonts = {
  heading: "Kaisei Decol, serif",
  body: "Kiwi Maru, serif",
  title: "Lexend Giga, sans-serif",
};

const fontSizes = {
  small: "12px",
  medium: "16px",
  large: "24px",
};

// Color palette
const colors = {
  text: {
    primary: "#13433a",
    secondary: "rgba(19, 67, 58, 0.6)",
    warning: "red",
  },
  background: {
    card: "rgba(255, 255, 255, 0.3)",
    dialog: "rgba(255, 255, 255, 0.9)",
  },
  accent: {
    red: "#e22f00",
    green: "#8cb808",
  },
};

const system = {
  fonts: fonts,
  fontSizes: fontSizes,
  colors: colors,
};
export default system;
